import { NgModule } from '@angular/core';

import { ScriptModule, ScriptService } from '@plugins/script';

import { MiddlewareSDKProxy } from './middleware-sdk.proxy';
import { SDK, STORE } from './middleware-sdk.tokens';
import { PlatformFeatureAvailablePipe } from './pipes/feature-available.pipe';
import { PlatformFeatureDisabledPipe } from './pipes/feature-disabled.pipe';
import { PlatformFeatureEnabledPipe } from './pipes/feature-enabled.pipe';
import { PlatformPermissionsAvailablePipe } from './pipes/permissions-available.pipe';

const pipes = [
  PlatformFeatureAvailablePipe,
  PlatformFeatureDisabledPipe,
  PlatformFeatureEnabledPipe,
  PlatformPermissionsAvailablePipe,
];

@NgModule({
  imports: [ScriptModule],
  providers: [
    {
      provide: SDK,
      useClass: MiddlewareSDKProxy,
      deps: [ScriptService],
    },
    {
      provide: STORE,
      useFactory: (sdk: MiddlewareSDKProxy) => sdk.store,
      deps: [SDK],
    },
  ],
  exports: [...pipes],
  declarations: [...pipes],
})
export class MiddlewareSdkModule {}
export { SDK, STORE };
